import React, { useEffect, useState } from 'react';
import { Hourglass } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-black text-white py-2 md:py-3 px-4 text-center font-bold" data-id="element-367">
      <div className="flex items-center justify-center gap-2" data-id="element-368">
        <Hourglass className="w-5 h-5 text-white animate-spin" style={{
        animationDuration: '2s'
      }} data-id="element-369" />
        <span data-id="element-370">
          ⚡ LIMITED TIME OFFER! Get 50% OFF - Ends in{' '}
          {String(timeLeft.hours).padStart(2, '0')}:
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}